import he from 'he';

export const decodeCustomPromos = (customPromos: string): string[] => {
  return JSON.parse(he.decode(customPromos));
};
